import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ShellContext = createContext(null);
const COLLAPSE_KEY = "medilearn_hrms_sidebar_collapsed";

/** Sidebar open (mobile drawer) and collapsed (desktop icon rail) state. */
export function ShellProvider({ children }) {
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(COLLAPSE_KEY) === "1"; } catch { return false; }
  });

  const setSidebarCollapsed = (v) => {
    setCollapsed(v);
    try { localStorage.setItem(COLLAPSE_KEY, v ? "1" : "0"); } catch { /* ignore */ }
  };

  useEffect(() => { setSidebarOpen(false); }, [pathname]);

  return (
    <ShellContext.Provider value={{ sidebarOpen, setSidebarOpen, sidebarCollapsed, setSidebarCollapsed }}>
      {children}
    </ShellContext.Provider>
  );
}

export const useShell = () => useContext(ShellContext);
